import { Tabs } from "shared/components/Tabs";
import { useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useAuthContext } from "providers/Auth";

const SCREENING_TABS_CONFIG = {
  tabs: ["screening-templates", "discounts"],
  displayMap: {
    "screening-templates": "Screening templates",
    discounts: "Discount codes"
  },
  routes: {
    "screening-templates": "/verification-templates",
    discounts: "/discounts"
  }
};

export const ScreeningTabs = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { permissions } = useAuthContext();

  const handleTabChange = (tab: string) => {
    const route = SCREENING_TABS_CONFIG.routes[tab];
    if (route) navigate(route);
  };

  const isDiscounts = pathname.includes("/discounts");
  const isScreeningTemplates = pathname.includes("/verification-templates");

  // Filter tabs based on permissions
  const availableTabs = useMemo(() => {
    const tabPermissions = {
      "screening-templates": permissions.canAccessScreeningTemplates !== false,
      discounts: permissions.canManageDiscounts !== false
    };

    return SCREENING_TABS_CONFIG.tabs.filter(
      (tab) => tabPermissions[tab] ?? true
    );
  }, [permissions.canAccessScreeningTemplates, permissions.canManageDiscounts]);

  const selected = useMemo(() => {
    if (isDiscounts) return "discounts";

    return "screening-templates";
  }, [isDiscounts, isScreeningTemplates]);

  return (
    <Tabs
      tabs={availableTabs}
      selected={selected}
      setActiveTab={handleTabChange}
      displayMap={SCREENING_TABS_CONFIG.displayMap}
      variant="underline"
    />
  );
};
